/* eslint-disable @typescript-eslint/no-explicit-any */
import {Text, View} from '@react-pdf/renderer';
import React from 'react';
import {DateToddmmyyyyFormat} from '../../../../data/factory';
import {styles} from './styles';

const getCurrentDate = () => DateToddmmyyyyFormat(new Date());

export const AttestationRCVP = (props: any) => {
  const {detailContrat} = props;
  return (
    <View>
      <View style={styles.section}>
        <Text style={styles.title}>ATTESTATION</Text>
      </View>
      <View style={styles.sousSection}>
        <View style={{margin: 10}} />
        <Text>
          Nous soussignés,{' '}
          <Text style={styles.textBolded}>
            {'ASSURANCES ET REASSURANCES OMNIBRANCHES <ARO>  '}
          </Text>{' '}
          dont le
        </Text>
        <Text>
          Siège Social est à Antsahavola ANTANANARIVO 101, attestons par la
          présente que :
        </Text>
        <View style={{margin: 2}} />
        <Text style={{alignSelf: 'center'}}>
          {detailContrat.nomPrenomContractant}
        </Text>
        <View style={{margin: 3}} />
        <Text>
          est assuré auprès de la Compagnie par une police d’Assurance{' '}
          <Text style={styles.textBolded}>{'RESPONSABILITE CIVILE VIE  '}</Text>
        </Text>
        <Text>
          <Text style={styles.textBolded}>PRIVEE N° </Text>{' '}
          {detailContrat.numeroPolice} pour la période du{' '}
          {detailContrat.dateSouscription} au {detailContrat.dateEcheance}{' '}
          suivant les
        </Text>
        <Text>conditions ci-après : </Text>
        {/* <Table data={AttestationBody}>
                    <TableHeader>
                        <TableCell textAlign="center" style={styles.textHeaderBolded}>{AttestationHead[0]}</TableCell>
                        <TableCell textAlign="center" style={styles.textHeaderBolded}>{AttestationHead[1]}</TableCell>
                        <TableCell textAlign="center" style={styles.textHeaderBolded}>{AttestationHead[2]}</TableCell>
                    </TableHeader>
                    <TableBody>
                        <DataTableCell style={styles.text} getContent={(r) => r.garanti} />
                        <DataTableCell style={styles.text} getContent={(r) => r.montant} />
                        <DataTableCell style={styles.text} getContent={(r) => r.franchise} />
                    </TableBody>
                </Table> */}
        <Text style={{marginTop: 10}}>
          La présente attestation lui est délivrée pour servir et valoir ce que
          de droit.{' '}
        </Text>
        <Text style={{...styles.textBolded, marginTop: 20}}>
          Fait à Antananarivo, le {getCurrentDate()}
        </Text>
        <View style={{margin: 5}} />
        <Text
          style={{...styles.textBolded, alignSelf: 'flex-end', marginLeft: 7}}>
          L’ASSUREUR{' '}
        </Text>
      </View>
    </View>
  );
};
